import { createContext } from 'react';

import { ExchangeRatesContextType } from '../../types';

const ExchangeRatesContext = createContext<ExchangeRatesContextType>([]);

export default ExchangeRatesContext;
